import { render, staticRenderFns } from "./UserLoginForm.vue?vue&type=template&id=122f5503"
import script from "./UserLoginForm.vue?vue&type=script&lang=js"
export * from "./UserLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports